import { useAuth } from "@/hooks/auth/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

export function useConversationReaderBroadcast() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user?.id) return;
    const topic = `conversation-readers:user:${user.id}`;
    const channel = supabase.channel(topic, { config: { private: true } });
    supabase.realtime.setAuth().then(() => {
      channel
        .on("broadcast", { event: "UPDATE" }, (payload) => {
          const updated = payload?.payload?.record;
          if (!updated?.character_id || !updated?.profile_id) return;
          queryClient.setQueryData(
            ["conversation-reader", user.id, updated.character_id],
            updated.reader_status,
          );
          if (
            payload.payload.old_record.reader_status === "answering" ||
            payload.payload.record.reader_status === "answering"
          ) {
            queryClient.invalidateQueries({
              queryKey: ["chat-history", user.id, updated.character_id],
            });
            queryClient.invalidateQueries({
              queryKey: ["conversations"],
            });
          }
        })
        .subscribe();
    });
    return () => {
      supabase.realtime.removeChannel(channel);
    };
  }, [user?.id, queryClient]);
}
